import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { customToast } from 'core-lib/utils/customToast';
import {
  getUserDetails,
  serializeCarData,
} from 'testDrive/utils/serializeCarData';
import { ListingType, ListType } from 'testDrive/types';

const serializeList = (data) => {
  const obj: ListingType = {
    list: data?.results?.map((item): ListType => serializeCarData(item)),
    isNotified: data?.is_notified,
    userCount: data?.yesterday_user_count,
    userDetails: getUserDetails(data?.user_details),
    question: data?.question,
    questionId: data?.question_id,
  };
  return obj;
};

export const fetchList = async (
  payload,
  isWidget = false,
  showToast = true
) => {
  let url = `${apiConfig('oem')}/v2/oem/leads/`;

  if (isWidget) {
    url += 'widgets';
  } else {
    url += 'filters';
  }

  const { response, error }: any = await postMethod({
    endPoint: url,
    body: payload,
  });

  if (response) {
    if (
      response?.data?.user_current_vehicle &&
      response?.data?.user_future_vehicle
    ) {
      return {
        currentCar: serializeCarData(response.data.user_current_vehicle),
        futureCar: serializeCarData(response.data.user_future_vehicle),
        list: [],
        userDetails: null,
        isNotified: null,
        userCount: null,
        question: response?.data?.question,
        questionId: response?.data?.question_id,
      };
    } else if (response?.data?.results) {
      return serializeList(response.data);
    }
  }
  if (error) {
    if (showToast) {
      customToast({
        label: error?.message || 'Something went wrong',
        variant: 'criticalNotPriority',
      });
    }
  }
  return null;
};
